import { render } from "./QuestionnaireSectionRow.vue?vue&type=template&id=70d72f8b&scoped=true"
import script from "./QuestionnaireSectionRow.vue?vue&type=script&lang=js"
export * from "./QuestionnaireSectionRow.vue?vue&type=script&lang=js"

import "./QuestionnaireSectionRow.vue?vue&type=style&index=0&id=70d72f8b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d72f8b"]])

export default __exports__